export default __webpack_public_path__ + "static/media/msb.7c43a56a.png";